/**
 * Подстановка диапазона дат по умолчанию
 * =======================================
 *
 * Глобальный диапазон дашборда может быть пустым (пользователь его не
 * выбирал). Для дашбордов по таблице событий это недопустимо: запрос без
 * предиката по дате уходит в полный скан prod_events_hole_alien (замеры:
 * 32-237 с на сессиях, 97 с на прогрессии), поэтому сервер такой запрос
 * отклоняет с 400. Виджеты этих дашбордов подставляют последние N полных
 * дней — тот же приём, что уже применён в ResourceFlowWidget.
 */

/** Окно по умолчанию, дней */
export const DEFAULT_RANGE_DAYS = 30;

/**
 * Последние N полных дней: сегодняшний день исключаем как неполный.
 * @param {number} days длина окна в днях
 * @returns {{ startDate: Date, endDate: Date }}
 */
export function lastFullDaysRange(days = DEFAULT_RANGE_DAYS) {
  const endDate = new Date();
  endDate.setDate(endDate.getDate() - 1);
  const startDate = new Date(endDate);
  startDate.setDate(startDate.getDate() - (days - 1));
  return { startDate, endDate };
}

/**
 * Возвращает фильтры с гарантированно заполненным диапазоном дат.
 * Исходный объект не мутируется.
 *
 * @param {Object} filters фильтры дашборда
 * @param {number} days длина окна по умолчанию
 * @returns {Object} копия фильтров с непустым dateRange
 */
export function withDefaultDateRange(filters, days = DEFAULT_RANGE_DAYS) {
  const { startDate, endDate } = filters?.dateRange || {};
  if (startDate && endDate) {
    return filters;
  }

  const range = lastFullDaysRange(days);
  return {
    ...filters,
    dateRange: range,
    // Поля верхнего уровня — для совместимости со старым форматом фильтров
    startDate: range.startDate,
    endDate: range.endDate
  };
}
